import { useRef as r, useCallback as f } from "../../external/preact/hooks/dist/hooks.module.js";
import u from "../useReflex.js";
import { uniqueId as o } from "../../utils/random/uniqueId.js";
const c = (n) => {
  const e = r();
  return u(
    f(
      (i, t) => {
        t instanceof Element && t.id === e.current && (t.id = ""), i instanceof Element && (i.id = e.current || (e.current = o()));
      },
      [n]
    ),
    n
  );
};
export {
  c as default
};
